import axios from 'axios';
import { UpdateMediaRequest } from '../../structures/requests/media';
import { Media } from '../../structures/models/media/media';
import routes from '../routes';

// eslint-disable-next-line import/prefer-default-export
export const updateMedia = async (mediaId: number, mediaInput: UpdateMediaRequest):
  Promise<Media> => {
  const response = await axios.put(routes.apiMediaUpdate(mediaId), mediaInput, { headers: { Accept: 'application/json' } });
  return response.data;
};

export const deleteMedia = async (mediaId: number):
  Promise<void> => {
  const response = await axios.delete(routes.apiMediaDelete(mediaId), { headers: { Accept: 'application/json' } });
};
